<script lang="ts">
  import type { RecentSearch } from './AiSearchContent.svelte';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { formatTimeAgo } from '$lib/utils/time';
  import { TwistStack } from '@twist/core';
  import HeadingSizeDecorator from '$components/Common/HeadingSizeDecorator.svelte';
  import FontSizeDecorator from '$components/SanityComponents/PortableText/Decorators/FontSizeDecorator.svelte';
  import BlockButton from '$components/Button/BlockButton.svelte';

  interface Props {
    handleSearch: (query: string) => void;
    recentSearches: RecentSearch[];
  }

  let { handleSearch, recentSearches }: Props = $props();
</script>

<div class="recent-searches">
  <h5 class="recent-searches-title">
    <HeadingSizeDecorator size="h5">Recent Queries</HeadingSizeDecorator>
  </h5>
  <div class="recent-searches-list">
    {#each recentSearches as { query, timestamp }}
      <BlockButton
        variant="fill"
        fullWidth={true}
        fontSize={toFluidVarInput(12, 12)}
        py={toFluidVarInput(12, 12)}
        px={toFluidVarInput(12, 12)}
        motion="never"
        onclick={() => handleSearch(query)}
      >
        <TwistStack direction="row" justify="space-between" spacing={toFluidVarInput(12, 12)}>
          <span class="query">
            <FontSizeDecorator size="caption">{query}</FontSizeDecorator>
          </span>
          <span class="timestamp">
            <FontSizeDecorator size="caption">
              {formatTimeAgo(timestamp)}
            </FontSizeDecorator>
          </span>
        </TwistStack>
      </BlockButton>
    {/each}
  </div>
</div>

<style lang="scss">
  @import 'src/scss/variables.scss';

  .recent-searches {
    margin: 16px 0;
    padding: 16px;
    background: $background-depth-1-color;
    border-radius: 12px;

    .recent-searches-title {
      margin: 0 0 12px;
    }
  }

  .recent-searches-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }
</style>
